import React, { Suspense, useState, useEffect, useRef } from "react";
import Drawer from 'react-modern-drawer';
import TransactionHistory from "../TransactionHistory";
import TransactionServices from "../TransactionServices";
import { Filter } from "filter";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function InvoiceUpdateField(param: any) {

    console.log(param)
    let [condition, setcondition] = useState(0);
    let [periodList, setPeriodList] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [updAllStatus, setupdAllStatus] = useState(false);
    let [updAdjStatus, setupdAdjStatus] = useState(false);
    let [showAnalysis, setshowAnalysis] = useState(false);
    let [showSubFormat, setshowSubFormat] = useState(true);
    let [showTerritory, setshowTerritory] = useState(false);
    let [updBlnkStatus, setupdBlnkStatus] = useState(false);
    let [updChngStatus, setupdChngStatus] = useState(false);
    let [updateFieldname, setupdateFieldname] = useState('');
    let [selectInvoice, setSelectInvoice] = useState<any>([]);
    let [showHeaderType, setshowHeaderType] = useState(false);
    let [updateFieldValue, setUpdateFieldValue] = useState('');
    let [showSubProvider, setshowSubProvider] = useState(false);
    let [showRoyaltyPeriod, setshowRoyaltyPeriod] = useState(false);
    let [analysisCodesList, setAnalysisCodesList] = useState<any>([]);
    let [territoryCodeList, setTerritoryCodeList] = useState<any>([]);

    useEffect(() => {

        if (param?.InvoiceUpdateSelect?.invoiceNum) {
            selectInvoice = param?.InvoiceUpdateSelect;
            setSelectInvoice(selectInvoice)
        }
    }, [param])

    const InvoiceUpdateFieldClose = () => { param.InvoiceUpdateFieldClose() }

    const approvedUpdateField = () => {
        if (updateFieldname == null || condition == null || updateFieldValue == null || (updateFieldname == 'knett_C')) {
            const message = `There was a problem submitting your request, one or more fields are missing or knett is not a numeric character`;
            CommonUtilities.showToastDawer(message, 'fail')
            return;
        }

        TransactionServices.updateField(updateFieldname, condition, updateFieldValue, selectInvoice.invoiceNum).then(function () {

            const message = `Account Detail for ${selectInvoice?.accountCode ?? ''} has been saved successfully.`;
            CommonUtilities.showToastDawer(message, 'Success')

            showSubFormat = true;
            showTerritory = false;
            showAnalysis = false;
            showHeaderType = false;
            showRoyaltyPeriod = false;

            if (updateFieldname == 'royaltyperiod') {
                selectInvoice.royaltyPeriod = updateFieldValue;
            }
            else if (updateFieldname == 'HeaderType') {
                selectInvoice.headerType = updateFieldValue;
            }

        });

    }

    const customPostSales = () => {
        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    }

    const approvedConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES 
        if (e == 1) {

            const userId = JSON.parse(sessionStorage.getItem("user") || "{}").userId;

            if (userId && selectInvoice.invId) {
                TransactionServices.customPostSales({ invoiceRef: selectInvoice.invId, userId: userId })
            }

        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    };

    const selectUpdateField = (field: any) => {
        console.log(field)
        updateFieldname = field
        setupdateFieldname(updateFieldname)

        updBlnkStatus = true;
        updAllStatus = true;
        updAdjStatus = true;
        updChngStatus = true;

        if (field == 'territory') {
            showSubFormat = false;
            showAnalysis = false;
            showHeaderType = false;
            showRoyaltyPeriod = false;
            showTerritory = true;
            condition = 1
            getAllTerritoriesCodes();

            updBlnkStatus = false;
            updAllStatus = false;

        }
        else if (field == 'analysis') {
            showSubFormat = false;
            showTerritory = false;
            showHeaderType = false;
            showRoyaltyPeriod = false;
            showAnalysis = true;
            condition = 1
            loadAllAnalysiCodes();

            updBlnkStatus = false;
            updAllStatus = false;

        }
        else if (field == 'royaltyperiod') {
            showTerritory = false;
            showAnalysis = false;
            showSubFormat = false;
            showHeaderType = false;
            showRoyaltyPeriod = true;
            condition = 3
            loadAllPeriod();
            updateFieldValue = selectInvoice.royaltyPeriod;

            updChngStatus = false;

        }
        else if (field == 'HeaderType') {
            showTerritory = false;
            showAnalysis = false;
            showSubFormat = false;
            showRoyaltyPeriod = false;
            showHeaderType = true;
            condition = 3
            updateFieldValue = selectInvoice.headerType;

            updChngStatus = false;
        }
        else {

            if (field == 'knett_C') {
                condition = 2
                updAdjStatus = false;
            }
            else if (field == 'SubFormat') {
                condition = 1
                updBlnkStatus = false;
                updAllStatus = false;
            }

            showTerritory = false;
            showAnalysis = false;
            showHeaderType = false;
            showRoyaltyPeriod = false;
            showSubFormat = true;
        }

        setcondition(condition)
        setupdAllStatus(updAllStatus)
        setupdAdjStatus(updAdjStatus);
        setshowAnalysis(showAnalysis);
        setupdBlnkStatus(updBlnkStatus);
        setupdChngStatus(updChngStatus);
        setshowSubFormat(showSubFormat);
        setshowTerritory(showTerritory);
        setshowHeaderType(showHeaderType);
        setshowSubProvider(showSubProvider);
        setUpdateFieldValue(updateFieldValue);
        setshowRoyaltyPeriod(showRoyaltyPeriod);
    };

    const loadAllPeriod = () => {
        TransactionServices.periodCount({}).then((respond: any) => setPeriodList(respond))
    }

    const getAllTerritoriesCodes = () => {
        TransactionServices.territoryCode({}).then((respond: any) => setTerritoryCodeList(respond))
    }

    const loadAllAnalysiCodes = () => {
        TransactionServices.contractsanalysisCodes().then((respond: any) => setAnalysisCodesList(respond))
    }

    return (<>
        <Drawer open={param.InvoiceUpdateFieldStatus} onClose={() => InvoiceUpdateFieldClose()} direction={"right"} className='react-drawer allowHscroll allowVscroll'>

            <div className="ws-6 box pull-right full-height-vh">
                <div className="box-header-main">
                    <h2 className="pull-left">Account Detail for  </h2>
                    <a className="icon-btn edit pull-left" title={"Acc: PRSO298144 Desc:" + selectInvoice?.invoiceNum}>{selectInvoice?.accountCode}</a>
                </div>

                <div className="box-content">

                    {false && <div className="alert alert-danger">There was a problem submitting your request, one or more fields are missing or knett is not a numeric character</div>}
                    {false && <div className="alert alert-success"> Account Detail for PRSO298144 has been saved successfully.</div>}

                    <div className="ws-12">
                        <div className="ws-4">
                            <div className="form-format">
                                <label className="control-label"  >Field to Update*</label>
                                <div className="label-entries">
                                    <select ng-model="update.fieldname" id="update.fieldname" name="fieldname" onChange={(e: any) => selectUpdateField(e.target.value)} required>
                                        <option value="" >Choose a field to Update</option>
                                        {!selectInvoice?.approvalStatus && <optgroup label="Update Fields">
                                            <option value="SubFormat" >Sub Formats/Source Codes</option>
                                            <option value="territory" >Territory</option>
                                            <option value="analysis" >Analysis</option>
                                            <option value="subprovider" >Subprovider</option>
                                        </optgroup>}

                                        {!selectInvoice?.approvalStatus && <optgroup label="Adjustment">
                                            <option value="knett_C" >Knett</option>
                                        </optgroup>}

                                        <optgroup label="Change Period">
                                            <option value="royaltyperiod" >Royalty Period</option>
                                        </optgroup>

                                        <optgroup label="Change Header Type">
                                            <option value="HeaderType" >Header Type</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="ws-4">
                            <div className="form-format">
                                <label className="control-label">Condition*</label>
                                <div className="label-entries">
                                    <select value={condition} id="condition" name="condition" required>
                                        <option value="" >Choose a condition</option>
                                        <option value="1" disabled={updBlnkStatus}>Blank</option>
                                        <option value="4" disabled={updAllStatus}>All</option>
                                        <option value="2" disabled={updAdjStatus}>Adjustment</option>
                                        <option value="3" disabled={updChngStatus}>Changes</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="ws-4">
                            <div className="form-format">
                                <label className="control-label">Value*</label>
                                <div className="label-entries">
                                    {showSubFormat && <input value={updateFieldValue} id="valueSubFormat" name="valueSubFormat" type="text" placeholder="Value" required />}

                                    {showTerritory && <select value={updateFieldValue} id="valueTerritory" name="valueTerritory" ng-value="value.territoryCode" required>
                                        <option value="" >Choose a territory</option>
                                        {
                                            territoryCodeList?.map((values: any) => {
                                                return (<option value={values.territoryCode} label={values.territoryCode + "(" + values.territoryName + ")"}></option>)
                                            })
                                        }
                                    </select>}

                                    {showAnalysis && <select value={updateFieldValue} id="valueAnalysis" name="valueAnalysis" ng-value="value.analysisCode" required>
                                        <option value="" >Choose a analysis code</option>
                                        {
                                            analysisCodesList?.map((values: any) => {
                                                return (<option value={values.analysisCode} label={values.analysisCode + "(" + values.analysisText + ")"}></option>)
                                            })
                                        }
                                    </select>}

                                    {showHeaderType && <select value={updateFieldValue} id="valueHeaderType" name="valueHeaderType" ng-value="value.type" required>
                                        <option value="" >Choose a header type</option>
                                        {
                                            TransactionServices.allHeaderType?.map((values: any) => {
                                                return (<option value={values.type} label={values.name}></option>)
                                            })
                                        }
                                    </select>}

                                    {showRoyaltyPeriod && <select value={updateFieldValue} id="valueRoyaltyPeriod" name="valueRoyaltyPeriod" ng-value="value.royaltyPeriod" required>
                                        <option value="" >Choose a period</option>
                                        {
                                            periodList?.map((values: any) => {
                                                return (
                                                    <option value={values?.periodDesc} label={Filter?.SimplemonthAndDayYear(values?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(values?.periodTo)} className={values?.periodOpen == 2 ? 'text-bold purple' : 'text-bold success'} >

                                                    </option>
                                                )
                                            })
                                        }
                                    </select>}

                                    {showSubProvider && <input value={updateFieldValue} id="valueSubprovider" name="valueSubprovider" type="text" placeholder="Value" required />}

                                </div>
                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete forceSingleLine height40" onClick={InvoiceUpdateFieldClose}><i className="icon-close"></i> Close</button>
                                <button className="icon-btn edit forceSingleLine height40" onClick={approvedUpdateField}><i className="icon-save"></i> Update</button>
                                <button className="icon-btn edit forceSingleLine height40" onClick={customPostSales}><i className="icon-save"></i> Post Custom</button>
                            </div>
                        </div>

                    </div>
                </div>
                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} message={"Process the Post Sales Adjustment for invoice :"} onChange={approvedConfirmation} />
                        }
                    })()
                }
            </div>

        </Drawer>
    </>)
}